/**
 * Environment configuration
 * All environment variables should be accessed through this file
 */

// Admin Service API base URL (includes /api/v1)
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:3002/api/v1';

// Admin Service base URL (without /api/v1) - used for static assets like profile images
// Extract from API_BASE_URL or use separate env variable
const getAdminServiceBaseUrl = (): string => {
  const apiBaseUrl = import.meta.env.VITE_API_BASE_URL;
  if (apiBaseUrl) {
    // Remove /api/v1 from the end if present
    return apiBaseUrl.replace(/\/api\/v1\/?$/, '');
  }
  // Default fallback
  return import.meta.env.VITE_ADMIN_SERVICE_URL || 'http://localhost:3002';
};

export const ADMIN_SERVICE_URL = getAdminServiceBaseUrl();

/**
 * Get full URL for a profile image path
 * @param imagePath - The image path (e.g., /uploads/profile-images/xxx.jpg)
 * @returns Full URL to the image
 */
export const getProfileImageUrl = (imagePath: string | null | undefined): string | null => {
  if (!imagePath) return null;
  
  // If already a full URL, return as is
  if (imagePath.startsWith('http')) {
    return imagePath;
  }
  
  // Otherwise, prepend the admin service base URL
  return `${ADMIN_SERVICE_URL}${imagePath}`;
};
